// Console error suppression for web - filters expected warnings while keeping real errors
// This should be imported early in the app lifecycle (in index.tsx)

// @ts-ignore - window is available in browser environment
if (typeof window !== 'undefined') {
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;

  // List of error/warning patterns to suppress (expected on web)
  const suppressPatterns = [
    /BackHandler is not supported on web/i,
    /BackHandler.*should not be used/i,
    /is not supported on web/i,
    /not available on web/i,
    /Video playback not available on web/i,
    /Video thumbnail generation not fully supported on web/i,
    /react-native-in-app-updates not available/i,
    /react-native-fs not available/i,
    /Skipping server config fetch on web/i,
    /Storage (getItem|setItem|removeItem) error/i,
    /Failed to transform.*with Babel/i,
    /shadow\*.*style props are deprecated/i,
    /textShadow\*.*style props are deprecated/i,
    /Access to fetch.*has been blocked by CORS/i,
    /Access to fetch.*from origin.*has been blocked/i,
    /Failed to fetch.*info\.json/i,
    /Error fetching remote configuration/i,
    /Failed to load server configuration/i,
    /Using fallback/i,
    /Download the React DevTools/i,
    /React DevTools/i,
    /Warning:.*is deprecated/i,
    /Warning:.*componentWillReceiveProps/i,
    /Warning:.*componentWillMount/i,
    /Warning:.*componentWillUpdate/i,
    /Warning:.*findDOMNode/i,
    /Warning:.*legacy context/i,
    /Unexpected text node/i,
    /A text node cannot be a child of a <View>/i,
  ];

  // Suppress console.error for expected web warnings
  console.error = (...args: any[]) => {
    if (args.length === 0) {
      originalConsoleError.apply(console, args);
      return;
    }
    
    const message = typeof args[0] === 'string' ? args[0] : args.map(String).join(' ');
    const shouldSuppress = suppressPatterns.some(pattern => pattern.test(message));
    
    if (!shouldSuppress) {
      originalConsoleError.apply(console, args);
    }
    // Silently suppress expected warnings
  };

  // Suppress console.warn for expected web warnings
  console.warn = (...args: any[]) => {
    if (args.length === 0) {
      originalConsoleWarn.apply(console, args);
      return;
    }
    
    const message = typeof args[0] === 'string' ? args[0] : args.map(String).join(' ');
    const shouldSuppress = suppressPatterns.some(pattern => pattern.test(message));
    
    if (!shouldSuppress) {
      originalConsoleWarn.apply(console, args);
    }
    // Silently suppress expected warnings
  };
}

export {};

